// ######################################################################
// ###   M e r g e   T w o   C o n f i g   J S O N s
// ######################################################################

const reducer = (json, currentValue) => {
  if (json && typeof json === 'object') {
    return json[currentValue];
  }
  return null;
};

export const setValue = (json, pathKey, value) => {
  const keys = pathKey.split('/');
  const field = keys.pop();
  const arg = keys.reduce(reducer, json);
  if (arg && typeof arg === 'object') {
    arg[field] = value;
  }
};

export const getValue = (json, pathKey) => {
  const keys = pathKey.split('/');
  return keys.reduce(reducer, json);
};

// General Functions
export function copyFromOtherJson(originalJson, originalKey, copyJson, copyKey) {
  const value = getValue(copyJson, copyKey);
  if (value !== null && value !== undefined) {
    setValue(originalJson, originalKey, value);
  }
}

export function addToJson(json, key, value) {
  setValue(json, key, value);
}

export function deleteFromJson(json, pathKey) {
  const keys = pathKey.split('/');
  const field = keys.pop();
  const arg = keys.reduce(reducer, json);
  if (arg && typeof arg === 'object' && arg[field] !== undefined) {
    delete arg[field];
  }
}
